import { brandInfo } from "../../constant";

export const initialState = {
  loading: false,
  services: [],
  products: [],
  microServices: [],
  logo: brandInfo.logo,
  logoWhite: brandInfo.logoWhite,
};
